import React from 'react';
import intervalAsync from 'mn-utils/async/interval';
import withState from '../../../utils/withState';


module.exports = withState((setState, self, onMount) => {
  let _node;
  let _nodeInner;
  let minus = 0;
  function handleRef(node) {
    _node = node;
  }
  function handleRefInner(node) {
    _nodeInner = node;
  }

  onMount(() => {
    return intervalAsync(() => {
      const w = _node && _node.offsetWidth || 0;
      const wi = (_nodeInner && _nodeInner.offsetWidth || 0) + 5;
      if (wi > w) {
        minus++;
      } else {
        if (wi < (w - 15)) {
          minus = Math.max(0, minus - 1);
        }
      }
      const value = self.props.value || '';
      const valueLength = value.length;
      const limit = valueLength - minus;
      const leftLength = Math.floor(limit * 0.5);
      const rightLength = limit - leftLength;

      const _value = valueLength > limit
        ? (value.substr(0, leftLength) + '...'
          + value.substr(length - rightLength, rightLength))
        : value;

      _value === value || setState({
        value: _value,
      });
    }, 50);
  });
  return (state, props) => {
    return (
      <div
        className="w ov tov"
        ref={handleRef}
      >
        <span ref={handleRefInner}>
          {state.value || props.value}
        </span>
      </div>
    );
  };
});
